(ns io.daskul.webapp.bootstrap
  "Pure helper for the webapp boot/readiness gate.

   Dependency-light (no React/re-frame) so it stays unit-testable on the shared
   :node-test harness — the same seam pattern as `io.daskul.webapp.nav`.")

(defn phase
  "Readiness phase. Hard-required: auth + config. Fail-safe: flags (settled on
   success OR error — a flag error never blocks).

   Input is the bootstrap substate:
     {:started? bool         ;; ::bootstrap has fired
      :authed?  bool         ;; a valid session exists
      :config   {:loaded? bool :error any}
      :flags    {:settled? bool :error any}}

   Phases: :idle → :loading → :ready, or :error when a hard-required fetch fails.
   `flags :settled?` is true once the flag fetch resolves either way, so a flag
   error reaches :ready (treat-all-flags-off, prod-safe) rather than blocking."
  [{:keys [started? authed? config flags]}]
  (cond
    (not (and started? authed?)) :idle
    (:error config)              :error     ;; hard-required failed → Retry
    (not (:loaded? config))      :loading
    (not (:settled? flags))      :loading   ;; config ok, flags still in flight
    :else                        :ready))   ;; flags settled = success OR error (fail-safe)

(defn status-copy
  "Splash status line. Escalates from the calm copy to a reassurance once the
   boot has been slow for a while (`slow?` flips after a few seconds)."
  [slow?]
  (if slow? "Still working…" "Loading your workspace…"))
